import { applyCreatedDependencies } from "./orchestration";

export const memberRecord = (member) => {
  if (!member || (!member.id && !member.value)) return null;
  const id = member.id || (member.value && member.value.id) || member.value;
  const name =
    member.name ||
    [member.firstName, member.lastName].filter(Boolean).join(" ") ||
    "";
  if (!id) return null;
  return {
    id,
    name,
    phone: member.phone || "",
    firstName: member.firstName || "",
    lastName: member.lastName || "",
  };
};

const dropMissing = (missing, labels) =>
  (missing || []).filter((item) => labels.indexOf(item) === -1);

const withSaved = (saved, field, value) => {
  const next = (saved || []).filter((item) => item && item.field !== field);
  if (value) next.unshift({ field, value });
  return next;
};

export const attachExistingMember = (drafts, draftId, member) => {
  const selected = memberRecord(member);
  if (!selected) return drafts || [];
  const created = { [draftId]: { id: selected.id, name: selected.name } };
  return (drafts || []).map((draft) => {
    const linked = applyCreatedDependencies(draft, created);
    if (draft.type === "sale" && draft.id === draftId) {
      return {
        ...linked,
        fields: {
          ...linked.fields,
          member: { id: selected.id, name: selected.name },
        },
        ready: true,
        fieldErrors: [],
        missing: dropMissing(linked.missing, [
          "Member",
          "Assign Sale to Member",
        ]),
        saved: withSaved(linked.saved, "Member", selected.name),
      };
    }
    if (draft.id !== draftId || draft.type !== "member") return linked;
    return {
      ...linked,
      existingMemberId: selected.id,
      fields: {
        ...linked.fields,
        id: selected.id,
        firstName: selected.firstName || linked.fields.firstName,
        lastName: selected.lastName || linked.fields.lastName,
        phone: selected.phone || linked.fields.phone,
        name: selected.name,
      },
      ready: true,
      missing: [],
      fieldErrors: [],
      saved: [
        {
          field: "First name",
          value: selected.firstName || linked.fields.firstName || selected.name,
        },
        selected.lastName || linked.fields.lastName
          ? {
              field: "Last name",
              value: selected.lastName || linked.fields.lastName,
            }
          : null,
        selected.phone
          ? { field: "Phone", value: selected.phone }
          : null,
      ].filter((item) => item && item.value),
    };
  });
};
